export const getCaminos = (state) => {
    return state.caminos_correos;
};
